module.exports = "<app-mark-classification-list></app-mark-classification-list>"